export enum PermissionEnum {
  VIEW = 'view',
  CREATE = 'create',
  UPDATE = 'update',
  REMOVE = 'remove',
  EXPORT = 'export',
}

export enum ResourceEnum {
  USERS = 'users',
  COURSES = 'courses',
  TRACKS = 'tracks',
  PROFILE = 'profile',
  DASHBOARD = 'dashboard',
  CERTIFICATES = 'certificates',
}

export type IamPermissionMap = Partial<Record<ResourceEnum, Partial<Record<PermissionEnum, string[]>>>>;

const permissionBase: IamPermissionMap = {
  [ResourceEnum.USERS]: {
    [PermissionEnum.VIEW]: ['admin:users:read'],
    [PermissionEnum.CREATE]: ['admin:users:create'],
    [PermissionEnum.UPDATE]: ['admin:users:update'],
    [PermissionEnum.REMOVE]: ['admin:users:delete'],
  },
  [ResourceEnum.COURSES]: {
    [PermissionEnum.VIEW]: ['app:courses:view'],
    [PermissionEnum.CREATE]: ['app:courses:enroll'],
    [PermissionEnum.UPDATE]: ['app:courses:complete'],
  },
  [ResourceEnum.TRACKS]: {
    [PermissionEnum.VIEW]: ['app:tracks:view'],
  },
  [ResourceEnum.PROFILE]: {
    [PermissionEnum.VIEW]: ['app:profile:read'],
    [PermissionEnum.UPDATE]: ['app:profile:update'],
  },
  [ResourceEnum.DASHBOARD]: {
    [PermissionEnum.VIEW]: ['app:dashboard:view'],
  },
  [ResourceEnum.CERTIFICATES]: {
    [PermissionEnum.VIEW]: ['app:certificates:view'],
    [PermissionEnum.CREATE]: ['app:certificates:issue'],
  },
};

export const permissionDev = (): IamPermissionMap => permissionBase;

export const permissionQas = (): IamPermissionMap => permissionBase;

export const permissionStaging = (): IamPermissionMap => permissionBase;

export const permissionProd = (): IamPermissionMap => permissionBase;
